import { render, staticRenderFns } from "./BaseStaticNotification.vue?vue&type=template&id=93eabe1c&"
import script from "./BaseStaticNotification.vue?vue&type=script&lang=js&"
export * from "./BaseStaticNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports